import { createContext, useContext } from "react";

export const EnquiryContext = createContext({ openBook: () => {} });
export const useEnquiry = () => useContext(EnquiryContext);
